const createMachine = (machineDef: { [key: string]: any }) => {
  const machine = {
    status: machineDef.initialStatus,
    transition(currentStatus: string, event: string) {
      const destinationStatus =
        typeof machineDef[currentStatus] === 'string' ? undefined : machineDef[currentStatus][event];
      if (!destinationStatus) {
        return currentStatus;
      }
      machine.status = destinationStatus;
      return machine.status;
    },
  };
  return machine;
};

export const statuses = {
  noCart: 'noCart',
  idle: 'idle',
  error: 'error',
  mutating: 'mutating',
};

export const events = {
  LOGOUT: 'LOGOUT',
  LOGIN: 'LOGIN',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  UPDATE: 'UPDATE',
};

const { LOGOUT, ERROR, SUCCESS, UPDATE } = events;
const { noCart, idle, error, mutating } = statuses;

export const cartMachine = createMachine({
  initialStatus: noCart,
  noCart: {
    [UPDATE]: mutating,
  },
  idle: {
    [LOGOUT]: noCart,
    [SUCCESS]: idle,
    [UPDATE]: mutating,
  },
  mutating: {
    [LOGOUT]: noCart,
    [ERROR]: error,
    [SUCCESS]: idle,
    [UPDATE]: mutating,
  },
  error: {
    [LOGOUT]: noCart,
    [SUCCESS]: idle,
    [UPDATE]: mutating,
  },
});
